import React from 'react';

import { AuthProvider } from './auth';
import { AppAuthProvider } from './appAuth';
import { AdminAuthProvider } from './adminAuth';
import { LanguageProvider } from './language';
import { ToastProvider } from './toast';
import { SettingsProvider } from './settings';
import { ProductsProvider } from './products';
import { CategoriesProvider } from './categories';
import { CartProvider } from './cart';
import { OrdersProvider } from './orders';
import { BannersProvider } from './banners';
import { ProductsCompanyProvider } from './productsCompany';
import { CategoriesCompanyProvider } from './categoriesCompany';
import { CartCompanyProvider } from './cartCompany';
import { ClientsProvider } from './clients';
import { DeliverymenProvider } from './deliverymens';
import { MenusProvider } from './menus';
import { SuppliesProvider } from './supplies';
import { CouponsProvider } from './coupons';
import { CashFlowProvider } from './cashFlow';
import { BackordersProvider } from './backorders';

const AppProvider: React.FC = ({ children }) => (
  <AuthProvider>
    <AdminAuthProvider>
      <AppAuthProvider>
        <MenusProvider>
          <SuppliesProvider>
            <ToastProvider>
              <SettingsProvider>
                <CouponsProvider>
                  <OrdersProvider>
                    <ProductsCompanyProvider>
                      <ProductsProvider>
                        <CategoriesProvider>
                          <CategoriesCompanyProvider>
                            <CartCompanyProvider>
                              <CartProvider>
                                <BannersProvider>
                                  <ClientsProvider>
                                    <DeliverymenProvider>
                                      <LanguageProvider>
                                        <CashFlowProvider>
                                          <BackordersProvider>
                                            {children}
                                          </BackordersProvider>
                                        </CashFlowProvider>
                                      </LanguageProvider>
                                    </DeliverymenProvider>
                                  </ClientsProvider>
                                </BannersProvider>
                              </CartProvider>
                            </CartCompanyProvider>
                          </CategoriesCompanyProvider>
                        </CategoriesProvider>
                      </ProductsProvider>
                    </ProductsCompanyProvider>
                  </OrdersProvider>
                </CouponsProvider>
              </SettingsProvider>
            </ToastProvider>
          </SuppliesProvider>
        </MenusProvider>
      </AppAuthProvider>
    </AdminAuthProvider>
  </AuthProvider>
);

export default AppProvider;
